export const USER_CHECKINS_LIST_GET = 'USER_CHECKINS_LIST_GET';
export const USER_CHECKINS_LIST_GET_SUCCESS = 'USER_CHECKINS_LIST_GET_SUCCESS';
export const USER_CHECKINS_LIST_GET_FAILURE = 'USER_CHECKINS_LIST_GET_FAILURE';



// WEBPACK FOOTER //
// ./shared/checkins/redux/actionTypes.js